// 是否悬浮提示
let focusTooltip = false
// 离开悬浮计时器
let hoverTimer = null
function getPopover() {
  let popover = document.querySelector('.my-tooltip-popover')
  if (!popover) {
    const temp = `<div class="my-tooltip-popover" style="position: fixed;z-index: 2022">
                    <div class="arrow-border"></div>
                    <div class="arrow-color"></div>
                    <div class="popover-content"></div>
                  </div>`
    const fragment = document.createRange().createContextualFragment(temp)
    document.body.appendChild(fragment)
    popover = document.querySelector('.my-tooltip-popover')
    if (popover) {
      popover.addEventListener('mouseenter', tooltipHover, false)
      popover.addEventListener('mouseleave', tooltipBlur, false)
    }
  }
  return popover
}

function showTitle(el, value) {
  const popover = getPopover()
  const popoverStyle = popover.style
  if (!value || value === undefined) {
    popoverStyle.display = 'none'
  } else {
    popoverStyle.display = 'block'
    // const elementStyle = window.getComputedStyle(el, null)
    const elRect = el.getBoundingClientRect()
    const popoverContent = popover.querySelector('.popover-content')
    const popoverArrow = popover.querySelector('.arrow-border')
    const arrowColor = popover.querySelector('.arrow-color')
    const popoverContentStyle = window.getComputedStyle(popoverContent, null)
    popoverContent.innerHTML = value
    popoverContent.style.background = '#fff'
    popoverContent.style.padding = '5px'
    popoverContent.style.border = '1px solid #000'
    popoverContent.style['border-radius'] = '5px'
    // popoverContent.style.margin = '20px'
    popoverArrow.style.position = 'absolute'
    popoverArrow.style['box-sizing'] = 'border-box'
    popoverArrow.style.height = '0px'
    popoverArrow.style.width = '0px'
    popoverArrow.style['z-index'] = '998'
    // popoverArrow.style['line-height'] = '16px'
    arrowColor.style.position = 'absolute'
    arrowColor.style['z-index'] = '999'
    // top处理
    if ((elRect.y + elRect.height + Number(popoverContentStyle.height.replace('px', '')) + 8) < window.innerHeight) {
      popoverContent.style['margin-top'] = '5px'
      popoverContent.style['margin-bottom'] = '0'
      popoverArrow.style.top = '0px'
      popoverArrow.style.bottom = 'auto'
      popoverArrow.style['border-left'] = '5px solid transparent'
      popoverArrow.style['border-right'] = '5px solid transparent'
      popoverArrow.style['border-bottom'] = '5px solid black'
      popoverArrow.style['border-top'] = '0'
      arrowColor.style.top = '1px'
      arrowColor.style.bottom = 'auto'
      arrowColor.style['border-left'] = '5px solid transparent'
      arrowColor.style['border-right'] = '5px solid transparent'
      arrowColor.style['border-bottom'] = '5px solid #fff'
      arrowColor.style['border-top'] = '0'
      popoverStyle.top = elRect.y + elRect.height + 'px'
    } else {
      // 触底
      popoverContent.style['margin-top'] = '0px'
      popoverContent.style['margin-bottom'] = '5px'
      popoverArrow.style.bottom = '0px'
      popoverArrow.style.top = 'auto'
      popoverArrow.style['border-left'] = '5px solid transparent'
      popoverArrow.style['border-right'] = '5px solid transparent'
      popoverArrow.style['border-top'] = '5px solid black'
      popoverArrow.style['border-bottom'] = '0'
      arrowColor.style.bottom = '1px'
      arrowColor.style.top = 'auto'
      arrowColor.style['border-left'] = '5px solid transparent'
      arrowColor.style['border-right'] = '5px solid transparent'
      arrowColor.style['border-top'] = '5px solid #fff'
      arrowColor.style['border-bottom'] = '0'
      popoverStyle.top = elRect.y - popoverContentStyle.height.replace('px', '') - 8 + 'px'
    }
    // left处理
    if (elRect.x + (elRect.width - popoverContentStyle.width.replace('px', '')) / 2 > 0 && elRect.x + (elRect.width + Number(popoverContentStyle.width.replace('px', ''))) / 2 < window.innerWidth) {
      popoverArrow.style.left = '50%'
      popoverArrow.style.right = 'auto'
      popoverArrow.style.transform = 'translateX(-50%)'
      arrowColor.style.left = '50%'
      arrowColor.style.right = 'auto'
      arrowColor.style.transform = 'translateX(-50%)'
      popoverStyle.left = elRect.x + (elRect.width - popoverContentStyle.width.replace('px', '')) / 2 + 'px'
      popoverStyle.right = 'auto'
    } else if (elRect.x + (elRect.width - popoverContentStyle.width.replace('px', '')) / 2 < 0) {
      popoverArrow.style.left = elRect.x + elRect.width / 2 + 'px'
      popoverArrow.style.right = 'auto'
      popoverArrow.style.transform = 'translateX(-50%)'
      arrowColor.style.left = elRect.x + elRect.width / 2 + 'px'
      arrowColor.style.right = 'auto'
      arrowColor.style.transform = 'translateX(-50%)'
      popoverStyle.left = 0
      popoverStyle.right = 'auto'
    } else {
      popoverArrow.style.left = 'auto'
      popoverArrow.style.right = window.innerWidth - (elRect.x + elRect.width / 2) + 'px'
      popoverArrow.style.transform = 'translateX(50%)'
      arrowColor.style.left = 'auto'
      arrowColor.style.right = window.innerWidth - (elRect.x + elRect.width / 2) + 'px'
      arrowColor.style.transform = 'translateX(50%)'
      popoverStyle.right = 0
      popoverStyle.left = 'auto'
    }
    popoverStyle['text-align'] = 'center'
  }
}

function tooltipHover() {
  focusTooltip = true
}

function tooltipBlur() {
  if (hoverTimer) {
    clearTimeout(hoverTimer)
  }
  showTitle()
  focusTooltip = false
  hoverTimer = null
}

export default {
  bind(el, binding, vnode) {
    // 显示悬浮计时器
    let timer = null
    // 是否悬浮节点
    let focusItem = false
    // item focus
    const handler = () => {
      if (!timer) {
        timer = setTimeout(() => {
          focusItem = true
          showTitle(el, binding.value)
          clearTimeout(timer)
          timer = null
        }, 500)
      }
    }
    // item blur
    const removeTimerHandler = () => {
      if (timer) {
        clearTimeout(timer)
      }
      focusItem = false
      timer = null
      // 延迟处理，防止鼠标悬浮不了
      hoverTimer = setTimeout(() => {
        if (!focusItem && !focusTooltip) {
          showTitle()
        }
      }, 100)
    }
    const mouseWheelHandler = (event) => {
      // const elRect = el.getBoundingClientRect()
      showTitle()
    }
    el.addEventListener('mouseenter', handler, false)
    el.addEventListener('mouseleave', removeTimerHandler, false)
    el.addEventListener('mousewheel', mouseWheelHandler, false)
    // 事件解绑
    el.destroy = () => {
      if (el && el.removeEventListener) {
        el.removeEventListener('mouseenter', handler, false)
        el.removeEventListener('mouseleave', removeTimerHandler, false)
      }
    }
  },
  unbind(el) {
    el.destroy()
  }
}
